import { render, staticRenderFns } from "./PreApproval.vue?vue&type=template&id=61106372&scoped=true&"
import script from "./PreApproval.vue?vue&type=script&lang=js&"
export * from "./PreApproval.vue?vue&type=script&lang=js&"
import style0 from "./PreApproval.vue?vue&type=style&index=0&id=61106372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61106372",
  null
  
)

export default component.exports